import { stringifySearchWith } from "@tanstack/react-router";

/**
 * Search-param codec that keeps scalar values as strings. TanStack's default JSON-encodes every value, which
 * quotes numeric-looking strings (`?m=%22210…%22`) and coerces `true` / small numbers on the way back in; a
 * pasted `?m=<snowflake>` must round-trip as the exact string. Only objects/arrays go through JSON.
 */
export function parseSearch(searchStr: string): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of new URLSearchParams(searchStr).entries()) {
    let parsed: unknown = value;
    if (value.startsWith("{") || value.startsWith("[")) {
      try {
        parsed = JSON.parse(value);
      } catch {
        parsed = value;
      }
    }
    out[key] = parsed;
  }
  return out;
}

export const stringifySearch = stringifySearchWith(JSON.stringify);
